import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function ContactPage(){
    return (
        <> 
            <Container>
                
                <Row className="bg-white rounded">
                    <Col md={{ span: 4, offset: 4 }}>
                        <p>Contact Sunset</p>
                    </Col>
                </Row>
                <Row className="bg-white rounded">
                    <Col md={{ span: 4, offset: 4 }}>
                        <form>
                        <div className="mb-3">
                            <input placeholder="Enter your name..." type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                        <div className="mb-3">
                            <input placeholder="Enter your email address..." type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                        <div className="mb-3">
                            <textarea placeholder="Your Message" className="form-control no-resize" id="exampleInputPassword1" rows={5} />
                        </div>
                        <button type="button" className="btn btn-secondary w-100">Send</button>
                        </form>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ContactPage;